export enum ExtensionTypeReference {
    TypeDocument = "TIPO_DOCUMENTAL"
}